<template>
  <span>
    <span
      :class="badgeClasses"
    >
      {{ badgeText }}
    </span>
    <span
      class="badge badge-secondary"
      v-if="isPermanentBounce"
    >
      Permanent Bounce
    </span>
  </span>
</template>
<script>
export default {
  props: {
    status: {
      type: String,
      default: 'queued'
    },

    statusType: {
      type: String,
      default: undefined
    },

    statusSubType: {
      type: String,
      default: undefined
    }
  },

  computed: {
    badgeClasses () {
      return `badge badge-${this[this.status]}`
    },

    badgeText () {
      return this.$root.capitalize(this.status)
    },

    bounced () {
      return 'danger'
    },

    isPermanentBounce () {
      return this.statusType === 'Permanent'
    },

    complained () {
      return 'dark'
    },

    delivered () {
      return 'success'
    },

    queued () {
      return 'warning'
    },

    sent () {
      return 'info'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EmailRecipientStatusBadge.vue